import { createSlice } from "@reduxjs/toolkit";
import { getOrderReportData } from "./ThunkAction";
import { ProFormaInvoce } from "./Types";

const initialState: ProFormaInvoce = {
  productDetail: null,
  dataList: null, // ✅ should be object, not array
  loadingList: false,
  loadingDataList: false,
  message: null,
  error: null,
  loading: false,
};

const orderReportSlice = createSlice({
  name: "orderReportState",
  initialState,
  reducers: {
    clearOrderReportData: (state) => {
      state.productDetail = null;
      state.dataList = null;
      state.loadingList = false;
      state.loadingDataList = false;
      state.message = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getOrderReportData.pending, (state) => {
        state.loadingDataList = true;
        state.error = null;
      })
      .addCase(getOrderReportData.fulfilled, (state, action) => {
        state.loadingDataList = false;
        state.dataList = action.payload?.data || null; // ✅ assign full object
        state.message = action.payload?.message || null;
      })
      .addCase(getOrderReportData.rejected, (state, action) => {
        state.loadingDataList = false;
        state.error = action.payload?.message || "Something went wrong";
      });
  },
});

export const { clearOrderReportData } = orderReportSlice.actions;
export default orderReportSlice.reducer;
